/* global google, GMaps */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';
import ThingsToDoSkeleton from '../components/ThingsToDoSkeleton/ThingsToDoSkeleton';
import mapStyles from '../util/mapStyles';

class AppHotelNeighborhood extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      loading: true,
      allThingsToDo: [],
      allThingToDoLocations: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.type = '';

    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = type;
    }

    // Bind "this"
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
    this.loadMap = this.loadMap.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState({
      loading: true,
      allThingsToDo: [],
      allThingToDoLocations: [],
      loadMoreLoading: false,
      loadedAll: false,
    });

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTEL_THINGS_TO_DO,
      'type': this.type,
      'offset': 0,
    };

    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const thingsToDoCount = response.data['things_to_do_count'];
          const thingsToDo = [...response.data['things_to_do']];
          const thingToDoLocations = response.data['thing_to_do_locations'];

          if (0 === thingsToDoCount) {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          } else {
            this.setState({
              loading: false,
              allThingsToDo: [...thingsToDo],
              allThingToDoLocations: [...thingToDoLocations],
              loadMoreLoading: false,
              loadedAll: thingsToDoCount == thingsToDo.length,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  loadMoreSearchResults(e) {
    e.preventDefault();

    const {
      allThingsToDo,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTEL_THINGS_TO_DO,
        'type': this.type,
        'offset': allThingsToDo.length,
      };

      axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const thingsToDoCount = response.data['things_to_do_count'];
            const thingsToDo = [
              ...allThingsToDo,
              ...response.data['things_to_do'],
            ];

            this.setState({
              loading: false,
              allThingsToDo: [...thingsToDo],
              loadMoreLoading: false,
              loadedAll: parseInt(thingsToDoCount) === thingsToDo.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  }

  loadMap() {
    if ($('#things-to-do-map-wrapper').length) {
      const { allThingToDoLocations } = this.state;
      if (allThingToDoLocations.length > 0) {
        // Setup first item on map
        const map = new GMaps({
          div: '#things-to-do-map-wrapper',
          scrollwheel: false,
          center: new google.maps.LatLng(allThingToDoLocations[0]['address']['lat'], allThingToDoLocations[0]['address']['lng']),
          zoom: 15,
          styles: mapStyles,
        });

        const mapMarkerInfoWindowTemplate = $('#map-marker-info-window').html();
        const bounds = [];

        for (let i = 0; i < allThingToDoLocations.length; i++) {
          if (Object.keys(allThingToDoLocations[i]).length > 0) {
            const title = allThingToDoLocations[i]['title'];
            const type = allThingToDoLocations[i]['type'];
            const image = allThingToDoLocations[i]['image'];
            const link = allThingToDoLocations[i]['link'];
            const dateLabel = allThingToDoLocations[i]['date_label'];
            const lat = allThingToDoLocations[i]['address']['lat'];
            const lng = allThingToDoLocations[i]['address']['lng'];
            const bgColor = allThingToDoLocations[i]['address']['bg_color'];
            const textColor = allThingToDoLocations[i]['address']['text_color'];

            bounds.push(new google.maps.LatLng(lat, lng));

            map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                scaledSize: new google.maps.Size(44, 44),
                url: allThingToDoLocations[i]['address']['marker_image'],
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  name: title,
                  type: type,
                  image: image,
                  link: link,
                  date: dateLabel,
                  bgColor: bgColor,
                  textColor: textColor,
                }, mapMarkerInfoWindowTemplate),
              },
            });
          }
        }

        if (allThingToDoLocations.length > 1) {
          map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  componentDidMount() {
    // Load results on first page load
    this.loadSearchResults();

    $(document).on(constants.EVENT_NEIGHBORHOOD_TYPES_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadSearchResults();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      this.loadMap();
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      allThingsToDo,
      loading,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        <div className="mb-8">
          <div className="map-wrapper skeleton-shine">
            { !loading && (
              <div id="things-to-do-map-wrapper" className="map" />
            )}
          </div>
        </div>

        <div className="articles-grid">
          <div className="article-wrapper">
            { !loading && allThingsToDo.length > 0 && (
              allThingsToDo.map((todo, i) => {
                return (
                  <a key={i} href={todo.link} className="article-item">
                    <div className="image-container">
                      <img src={todo.image} alt="" />
                    </div>
                    <div className="content-container">
                      <div className="article-category">
                        {todo.type}
                      </div>

                      <div className="article-date">
                        {todo.date_label}
                      </div>

                      <h3 className="article-title">
                        {todo.title}
                      </h3>

                      <span className="btn btn-view">View Details</span>
                    </div>
                  </a>
                );
              })
            )}
            {(loading || loadMoreLoading) && (
              <ThingsToDoSkeleton />
            )}
          </div>
        </div>

        <div className="cta-wrapper">
          <button className="btn btn-outline-black"
            disabled={loading || loadMoreLoading || loadedAll }
            onClick={this.loadMoreSearchResults}
          >
            {!loadedAll ? 'Load More' : 'That\'s All'}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default{
  init() {
  },
  finalize() {
    const hotelThingsToDoWrapper = $('#hotel-things-to-do-wrapper');
    if (hotelThingsToDoWrapper.length) {
      ReactDOM.render(<AppHotelNeighborhood/>, hotelThingsToDoWrapper[0]);
    }

    const neighborhoodSortTypes = $('#neighborhood-sort-types');
    if (neighborhoodSortTypes.length) {
      neighborhoodSortTypes.on('select2:select', function () {
        const _this = $(this);
        const params = helpers.getParameters();

        const extractBeforeBg = (str) => {
          return str.split('-bg')[0];
        };

        const selectedVal = extractBeforeBg(_this.val());

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_NEIGHBORHOOD_TYPES_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelNeighborhood.js